import React from 'react';
import { Card, Empty, Tag } from 'antd';
import Chart from 'react-apexcharts';
import { ApiOutlined } from '@ant-design/icons';

const NetworkChart = ({ servidor, height = 300 }) => {
  if (!servidor?.datos?.length) {
    return <Card title={servidor?.nombre || 'Sin datos'}><Empty description="No hay datos de red disponibles" /></Card>;
  }

  const labels = servidor.datos.map(d => new Date(d.timestamp).getTime());
  const rxData = servidor.datos.map(d => d.rx);
  const txData = servidor.datos.map(d => d.tx);
  const conexionesData = servidor.datos.map(d => d.conexiones);

  const rxPromedio = (rxData.reduce((a, b) => a + b, 0) / rxData.length).toFixed(3);
  const txPromedio = (txData.reduce((a, b) => a + b, 0) / txData.length).toFixed(3);
  const rxMax = Math.max(...rxData).toFixed(3);
  const txMax = Math.max(...txData).toFixed(3);
  const conexionesPromedio = Math.round(conexionesData.reduce((a, b) => a + b, 0) / conexionesData.length);
  const conexionesMax = Math.max(...conexionesData);

  return (
    <Card
      title={
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 8 }}>
          <span><ApiOutlined style={{ marginRight: 8 }} />{servidor.nombre}{servidor.ip && <span style={{ fontSize: 12, color: '#888', marginLeft: 8 }}>({servidor.ip})</span>}</span>
          <span style={{ fontSize: 12, fontWeight: 'normal' }}>
            <Tag color="blue">RX avg: {rxPromedio} MB/s (max: {rxMax})</Tag>
            <Tag color="green">TX avg: {txPromedio} MB/s (max: {txMax})</Tag>
            <Tag color="orange">Conex avg: {conexionesPromedio} (max: {conexionesMax})</Tag>
          </span>
        </div>
      }
      style={{ marginBottom: 16 }}
    >
      <Chart
        type="line"
        height={height}
        options={{
          chart: { toolbar: { show: false }, zoom: { enabled: true } },
          stroke: { width: [2, 2, 2], curve: 'smooth' },
          colors: ['#3b82f6', '#10b759', '#fd7e14'],
          fill: { type: ['gradient', 'gradient', 'solid'], gradient: { opacityFrom: 0.2, opacityTo: 0.05 } },
          xaxis: { type: 'datetime', categories: labels, labels: { datetimeFormatter: { hour: 'HH:mm', day: 'dd/MM' } } },
          yaxis: [
            { title: { text: 'Tráfico (MB/s)' }, min: 0, labels: { formatter: v => v.toFixed(3) } },
            { opposite: true, title: { text: 'Conexiones' }, min: 0, labels: { formatter: v => Math.round(v).toString() } },
          ],
          grid: { borderColor: '#e5e9f2', strokeDashArray: 3 },
          tooltip: {
            x: { format: 'dd/MM HH:mm' },
            y: { formatter: (v, { seriesIndex }) => seriesIndex < 2 ? `${v.toFixed(3)} MB/s` : `${v}` },
          },
          legend: { position: 'top' },
          dataLabels: { enabled: false },
        }}
        series={[
          { name: 'RX (MB/s)', data: rxData, type: 'area' },
          { name: 'TX (MB/s)', data: txData, type: 'area' },
          { name: 'Conexiones', data: conexionesData, type: 'line' },
        ]}
      />
    </Card>
  );
};

export default NetworkChart;
